import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
      name: 'uppercaseNumber'
})
export class UppercaseNumberPipe implements PipeTransform {
      transform(value: number): any {
            // Check if value is a valid number
            if (isNaN(value)) {
                  return value;
            }
            if (!value) {
                  return value;
            }

            // Convert the number to a string and then to uppercase
            return value.toString().toUpperCase();
      }
}
